<template>
  <div>
    <h3>匹配管理</h3>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item label="职位id">
        <el-input v-model="filter.jobId" placeholder="职位id"></el-input>
      </el-form-item>
      <el-form-item label="乙方id">
        <el-input
          v-model.number="filter.userId"
          placeholder="乙方id"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch(1)" size="mini"
            >查询</el-button
          >
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="jobId" label="职位编号"></el-table-column>
      <el-table-column prop="title" label="职位名称">
        <template slot-scope="scope">
          <a
            :href="`${frontUrl}/job/detail/${scope.row.jobId}`"
            target="_blank"
            >{{ scope.row.title }}</a
          >
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="乙方id"></el-table-column>
      <el-table-column prop="nickname" label="乙方昵称">
        <template slot-scope="scope">
          <a
            :href="`${frontUrl}/resume/detail/${scope.row.userIdEnc}`"
            target="_blank"
            >{{ scope.row.nickname }}</a
          >
        </template>
      </el-table-column>
      <el-table-column prop="pushRule" label="匹配类型">
        <template slot-scope="scope">{{
          map.match.pushRule[scope.row.pushRule]
        }}</template>
      </el-table-column>
      <el-table-column prop="isAccurate" label="匹配结果">
        <template slot-scope="scope">{{
          map.match.status[scope.row.isAccurate]
        }}</template>
      </el-table-column>
      <el-table-column prop="pushTime" label="匹配时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button-group size="mini">
            <el-button
              size="mini"
              type="success"
              :disabled="scope.row.isAccurate === -1 ? false : true"
              @click="update(1, scope.row.id)"
              >合适</el-button
            >
            <el-button
              size="mini"
              type="success"
              :disabled="scope.row.isAccurate === -1 ? false : true"
              @click="toggleDialog('mismatch', scope.row)"
              >不合适</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="请选择不合适的原因"
      :visible.sync="dialog.mismatch"
      width="30%"
      class="dialog-mismatch"
    >
      <el-form ref="mismatchForm" :model="mismatchForm" :rules="rules">
        <el-form-item label="" prop="inaccurateReason">
          <el-radio-group v-model="mismatchForm.inaccurateReason">
            <el-radio
              v-for="(value, key) in map.match.reason"
              :key="key"
              :label="key"
              >{{ value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-input
            type="textarea"
            :rows="3"
            v-model="mismatchForm.inaccurateRemark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="toggleDialog('mismatch')">取 消</el-button>
        <el-button type="primary" @click="submitMismatch">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";

const { match } = api;

export default {
  name: "matchList",
  data() {
    return {
      map,
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      filter: {
        jobId: "",
        userId: "",
      },
      mismatchForm: {
        inaccurateReason: "",
        inaccurateRemark: "",
      },
      dialog: {
        mismatch: false,
      },
      curData: {},
      rules: {
        inaccurateReason: [{ required: true, message: "请选择不合适的原因" }],
      },
    };
  },
  components: {},
  computed: {
    jobId() {
      return this.$route.query.jobId;
    },
  },
  watch: {
    pageNum() {
      this.fetch(2);
    },
    "curData.id"() {
      this.mismatchForm.inaccurateReason = "";
      this.mismatchForm.inaccurateRemark = "";
      this.$refs["mismatchForm"] && this.$refs["mismatchForm"].resetFields();
    },
  },
  methods: {
    toggleDialog(name, data) {
      this.dialog[name] = !this.dialog[name];
      if (data) {
        this.curData = data;
      } else {
        this.curData = {};
        this.mismatchForm.inaccurateReason = "";
        this.mismatchForm.inaccurateRemark = "";
      }
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }

      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let { jobId, userId } = this.filter;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        jobId,
        userId: Number.isInteger(userId) ? userId : "",
      };

      let res = await match.list(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    async update(status, id) {
      let { inaccurateReason, inaccurateRemark } = this.mismatchForm;

      let obj = {
        id: id,
        isAccurate: status,
        inaccurateReason: status === 1 ? "" : inaccurateReason,
        inaccurateRemark: status === 1 ? "" : inaccurateRemark,
      };
      let res = await match.update(obj);
      if (res.data.code == 200) {
        this.fetch();
        if (!status) this.toggleDialog("mismatch");
      }
    },
    submitMismatch() {
      this.$refs["mismatchForm"].validate((valid) => {
        if (valid) {
          this.update(0, this.curData.id);
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    if (this.jobId) this.filter.jobId = this.jobId;
    this.fetch();
  },
};
</script>
<style>
.dialog-mismatch .el-radio {
  display: block;
  margin: 0;
  line-height: 24px;
}
.dialog-mismatch .el-radio + .el-radio {
  margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/match/matchs.vue